// extracted by mini-css-extract-plugin
module.exports = {"container":"SkeletonTabsList_container__21f-a"};